module.exports = {
      id: "pen-usage",
      viewBox: "0 0 20 20",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#pen",
      toString: function () {
        return this.url;
      }
    }